import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import moment from 'moment';

class BillReminderService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
  }

  load = action(async () => {
    this.fetch
      .fetch({
        url: '/bills',
        query: {
          query: {
            status: 'SENT_TO_CLIENT',
            dueDate: {
              $gte: moment().add(1, 'day').toISOString(),
              $lte: moment().add(1, 'day').toISOString(),
            },
          },
          page: 1,
          size: 1,
        },
      })
      .then(() => {
        if (this.fetch.data && this.fetch.data.total) {
          this.isOpen = true;
        } else {
          this.isOpen = false;
        }
      });
  });

  close = action(() => {
    this.isOpen = false;
  });
}

export default BillReminderService;
